<template>
  <kst-section search-mode>
    <template #top-left>
      <kst-button slim-size reset-mode @click="handleReset"/>
    </template>

    <form novalidate @submit.prevent="debounceSearch">
        <slot :handleInput="handleInput"/>

        <div class="is-hidden">
          <input type="submit" value="Cari" class="is-hidden">
        </div>
    </form>
  </kst-section>
</template>

<script>
import SearchMixin from "../../../mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  created() {
    this.initSearch(null, this.submit);
  },
  methods: {
    /*** component ***/

    handleInput() {
      this.handleSearch();
    },

    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    },

    /*** custom ***/

    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    }
  }
}
</script>